import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next';
import { useFormContext } from 'react-hook-form';

import { Title } from '../title';

import CPDBundleLicenseSummary from './licenseSummary/product';
import ProductSelectedCourseAndRoundSummary, { CourseRound } from './selectedCourseAndRoundSummary/product';

import LicenseSummary from '@components/molecules/cpdEnrollment/confirmAllInformation/licenseSummary';
import PersonSummary from '@components/molecules/cpdEnrollment/confirmAllInformation/personSummary';
import SelectedCourseAndRoundSummary from '@components/molecules/cpdEnrollment/confirmAllInformation/selectedCourseAndRoundSummary';
import { SummaryInformationContainer } from '@components/molecules/cpdEnrollment/confirmAllInformation/style';
import { CPDEnrollmentForm } from 'src/helpers/constants';
import { ICPDCourse, ICourse, LicenseRenewalTypeEnum } from 'src/interfaces';

type ConfirmInformationProps = {
  cpdCourses: ICPDCourse[];
  regCourses: ICourse[];
};

const ConfirmAllBundleInformation = ({ cpdCourses, regCourses }: ConfirmInformationProps) => {
  const { t } = useTranslation();

  const { getValues } = useFormContext();
  const cpdEnrollmentForm = getValues();

  const haveOicFourthPlus = cpdCourses.some(
    (course) => course.licenseRenewal === LicenseRenewalTypeEnum.FourthPlusRenewal,
  );

  return (
    <>
      <Title
        title={t('cpd_enrollment.confirm_information')}
        subtitle={t('cpd_enrollment.consent.bundle.product_info.header.subtitle')}
      />
      <SummaryInformationContainer>
        <PersonSummary
          person={{
            firstName: cpdEnrollmentForm.firstName,
            lastName: cpdEnrollmentForm.lastName,
            citizenId: cpdEnrollmentForm.citizenId,
            mobile: cpdEnrollmentForm.mobile,
            prefix: cpdEnrollmentForm.prefix as string,
            inputPrefix: cpdEnrollmentForm.inputPrefix as string,
            email: cpdEnrollmentForm.email as string,
          }}
        />
        <CPDBundleLicenseSummary cpdEnrollmentForm={cpdEnrollmentForm} haveOicFourthPlus={haveOicFourthPlus} />
        <ProductSelectedCourseAndRoundSummary
          coursesRound={cpdEnrollmentForm.courses as CourseRound[]}
          regCourses={regCourses}
        />
      </SummaryInformationContainer>
    </>
  );
};

export default ConfirmAllBundleInformation;
